var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 6.4002c0-1.76732 1.43269-3.2 3.2-3.2h9.6c1.7673 0 3.2 1.43268 3.2 3.2v22.4l-8-4-8 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFolder);
export default __webpack_public_path__ + "static/media/favorite-folder.49694ee731c29ce69ad4b079a45ee8a3.svg";
export { ForwardRef as ReactComponent };